import { Layout, Spin } from 'antd';
import { useContext } from 'react';
import { useStore } from 'zustand';

import { ModernHotelContext } from 'app/context/HotelContext/ModernHotelContext';

import { EmptyState } from '../../ExtranetInventory/Modern/_components/EmptyState/EmptyState';

import styles from './ExtranetPackages.module.scss';
import { PackType, packagesStore } from './PackageStore';
import { PackagesAlert } from './_components/PackagesAlert/PackagesAlert';
import { PackagesHeader } from './_components/PackagesHeader/PackagesHeader';
import { PackagesTables } from './_components/PackagesTables/PackagesTables';
import { useFilteredPackages } from './_hooks/useFilterPackages';
import { usePackContent } from './_hooks/usePackContent';

const PAGE = 'Packages';

export const ExtranetPackages = () => {
  const { experiences, pricingTotals, addOns, rooms } = usePackContent();

  const { filteredNightStayPacks, filteredDaytimePacks } =
    useFilteredPackages();
  const { isLoading } = useContext(ModernHotelContext);

  const packType = useStore(packagesStore, (state) => state.packType);

  const isDaytime = packType === PackType.DAYTIME;

  const isEmpty =
    (isDaytime ? filteredDaytimePacks : filteredNightStayPacks).length === 0;

  return (
    <Layout className={styles.extranetPackages}>
      <Spin
        spinning={isLoading && isEmpty}
        size="default"
        wrapperClassName={styles.packagesContentContainer}
      >
        <PackagesHeader page={PAGE} />
        {isEmpty ? (
          <div className={styles.packageEmptyStateContainer}>
            <EmptyState
              title={
                isDaytime ? 'Create new day packages' : 'Create new packages'
              }
              subtitle={
                isDaytime
                  ? 'Attract more users by offering new day packages that showcase your activities.'
                  : 'Attract more users by offering new packages that showcase your activities.'
              }
            />
          </div>
        ) : (
          <div className={styles.extranetPackagesContainer}>
            <PackagesAlert />
            <PackagesTables
              experiences={experiences}
              pricingTotals={pricingTotals}
              addOns={addOns}
              rooms={isDaytime ? undefined : rooms}
            />
          </div>
        )}
      </Spin>
    </Layout>
  );
};
